import React, { useRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { FaCaretDown } from "react-icons/fa";

const KpisFilterModal = ({ onSelectionChange, isSingleSelect = false }) => {
  const translation = useSelector((state) => state.root.translation);
  let { listKpis2 } = useSelector((state) => state.filter);
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedKpis, setSelectedKpis] = useState([]);

  const handleCheckboxChange = (name) => {
    let updatedSelection = isSingleSelect ? [name] : 
      selectedKpis.includes(name) 
        ? selectedKpis.filter((key) => key !== name) 
        : [...selectedKpis, name];

    setSelectedKpis(updatedSelection);
    onSelectionChange(updatedSelection);
  };

  const showDropDown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const handleSelectAllChange = () => {
    let updatedSelection = selectedKpis.length === listKpis2.length ? [] : listKpis2;
    setSelectedKpis(updatedSelection);
    onSelectionChange(updatedSelection);
  };
  return (
    <div ref={dropdownRef} className="dropdown select-store-dropdown">
      <div className="dropdown-toggle nav-link select-store" onClick={showDropDown}>
        <span className="user-name">
          <i className="fas fa-calendar-alt"></i> {translation["kpis"]}{" "}
          {`(${selectedKpis.length})`} <FaCaretDown />
        </span>
      </div>
      <div className={"dropdown-menu dropdown-menu-right" + (isOpen ? " show" : "")} style={{ maxHeight: "200px", overflowY: "auto", width:"100%"}}>
        {!isSingleSelect && (
          <div className="dropdown-item custom-label">
            <label className="d-flex align-items-center">
              <input
                type="checkbox"
                checked={selectedKpis.length === listKpis2.length}
                onChange={handleSelectAllChange}
                className="me-2"
              />
              {translation["all"] || "All"}
            </label>
          </div>
        )}
        {listKpis2.map((option) => (
          <div key={option} className="dropdown-item custom-label">
            <label className="d-flex align-items-center">
              <input
                type="checkbox"
                checked={selectedKpis.includes(option)}
                onChange={() => handleCheckboxChange(option)}
                className="me-2"
              />
              {translation[option] || option}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

// ✅ Define prop-types
KpisFilterModal.propTypes = {
  onSelectionChange: PropTypes.func.isRequired,
  isSingleSelect: PropTypes.bool, // Pass true for single selection mode
};

export default KpisFilterModal;

// import React, { useRef, useEffect, useState } from "react";
// import PropTypes from "prop-types";
// import { useSelector } from "react-redux";
// import { FaCaretDown } from "react-icons/fa";

// const KpisFilterModal = ({ onSelectionChange }) => {
//   const translation = useSelector((state) => state.root.translation);
//   let { listKpis2 } = useSelector((state) => state.filter);
//   const dropdownRef = useRef(null);
//   const [isOpen, setIsOpen] = useState(false);
//   const [selectedKpis, setSelectedKpis] = useState([]);

//   // if (!listKpis2) {
//   //   listKpis2 = ["sls"];
//   // }

//   const handleCheckboxChange = (name) => {
//     let updatedSelection = selectedKpis.includes(name)
//       ? selectedKpis.filter((key) => key !== name)
//       : [...selectedKpis, name];

//     setSelectedKpis(updatedSelection);
//     onSelectionChange(updatedSelection);
//   };

//   const handleSelectAllChange = () => {
//     let updatedSelection = selectedKpis.length === listKpis2.length ? [] : listKpis2;
//     setSelectedKpis(updatedSelection);
//     onSelectionChange(updatedSelection);
//   };

//   const showDropDown = () => {
//     setIsOpen(!isOpen);
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <div ref={dropdownRef} className="dropdown select-store-dropdown">
//       <div className="dropdown-toggle nav-link select-store" onClick={showDropDown}>
//         <span className="user-name">
//           <i className="fas fa-calendar-alt"></i> {translation["kpis"]}{" "}
//           {`(${selectedKpis.length})`} <FaCaretDown />
//         </span>
//       </div>
//       <div className={"dropdown-menu dropdown-menu-right" + (isOpen ? " show" : "")} style={{ maxHeight: "200px", overflowY: "auto" }}>
//         <div className="dropdown-item custom-label">
//           <label className="d-flex align-items-center">
//             <input
//               type="checkbox"
//               checked={selectedKpis.length === listKpis2.length}
//               onChange={handleSelectAllChange}
//               className="me-2"
//             />
//             {translation["All"]}
//           </label>
//         </div>
//         {listKpis2.map((option) => (
//           <div key={option} className="dropdown-item custom-label">
//             <label className="d-flex align-items-center">
//               <input
//                 type="checkbox"
//                 checked={selectedKpis.includes(option)}
//                 onChange={() => handleCheckboxChange(option)}
//                 className="me-2"
//               />
//               {translation[option] || option}
//             </label>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// // ✅ Define prop-types
// KpisFilterModal.propTypes = {
//   onSelectionChange: PropTypes.func.isRequired,
// };

// export default KpisFilterModal;
